import { render, staticRenderFns } from "./AdditionalItems.vue?vue&type=template&id=4dfaf186&"
import script from "./AdditionalItems.vue?vue&type=script&lang=js&"
export * from "./AdditionalItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports